// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/calculators/calculators.component.scss
// module id = 165
// module chunks = 0